const mutation = {
  initialReset(state) {
    state.list = [];
    state.filter = {};
    state.filter.page = 1;
    state.hasEmpty = false;
    state.isLoading = false;
  },

  paginationCheck(state, status) {
    state.isPaginating = status;
  },

  SET_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_PAGE(state, data) {
    state.filter.page = data;
  },

  SET_LIST(state, data) {
    const result = (state.filter.page > 1) ? state.list.concat(data) : data;
    state.list = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  UPDATE_LIST(state, data) {
    const result = state.list.filter(wallet => wallet.id !== data.id);
    state.list = [data, ...result];
  }
};

export default mutation;
